import React, {useState, useCallback} from 'react'
import PropTypes from 'prop-types'
import {getCouponPdf} from '../../lib/emmiApi'
import {LOG_EVENTS} from 'wipi-common/src/lib/logging/events'
import {Navigate} from "react-router-dom"
import './StartBasic.scss'
import LOG from "wipi-common/src/lib/logging/logger"
import {useI18nContext} from "../i18n/I18nContext";
import {getI18nTextWithContext} from "wipi-common/src/lib/i18n";

export default function DownloadCouponButton({caseId, hasIdent, couponData, setCouponData, backToBranchUrl, search}) {
    const [isDownloading, setDownloading] = useState(false);
    const [redirectTo, setRedirectTo] = useState(false);
    const context = useI18nContext()
    const buttonDescription = getI18nTextWithContext(context, 'startBasic.dlCouponBtn')

    const downloadCoupon = useCallback(() => {
        setDownloading(true);
        LOG.logInfo(LOG_EVENTS.BA_COUPON_DOWNLOAD);
        Promise.resolve(couponData || downloadPdf(caseId, setCouponData))
            .then(offerAsFile)
            .catch(() => {
                setRedirectTo(false);
            })
            .then(() => {
                setDownloading(false);
                setRedirectTo(true);
            })
    }, [caseId, couponData, setCouponData]);


    if (backToBranchUrl && redirectTo) {
        return <Navigate to={{pathname: "/basic/after-coupon-download", search}}/>
    }
    return <button
        className={"btn btn-primary btn-block" + (hasIdent && isDownloading ? " btn-disabled" : "")}
        onClick={downloadCoupon}
        data-test-id="190523bc-40ef"
        disabled={hasIdent && isDownloading}
        aria-label={buttonDescription}>
        {buttonDescription} &nbsp;
        {(hasIdent && isDownloading) ?
            <svg className="method-deactivated-icon" width="25" height="25" viewBox="0 0 25 25" fill="none"
                 aria-label="method deactivated icon" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_6664_4709)">
                    <circle id="circle" cx="12.5" cy="12.5" r="8"/>
                    <path id="inner-circle"
                          d="M15.3753 9.19182L15.8023 8.76061L15.2974 8.42397C14.5053 7.89597 13.5702 7.56 12.5 7.56C9.76386 7.56 7.56 9.76386 7.56 12.5C7.56 13.5719 7.89736 14.5165 8.5 15.32L8.84761 15.7835L9.25527 15.3718L15.3753 9.19182ZM9.62473 15.8082L9.1977 16.2394L9.70265 16.576C10.4947 17.104 11.4298 17.44 12.5 17.44C15.2317 17.44 17.4436 15.239 17.38 12.4939C17.3787 11.4262 17.043 10.4932 16.516 9.70265L16.176 9.19265L15.7447 9.62818L9.62473 15.8082ZM7 12.5C7 9.47614 9.47614 7 12.5 7C15.5239 7 18 9.47614 18 12.5C18 15.5239 15.5239 18 12.5 18C9.47614 18 7 15.5239 7 12.5Z"/>
                </g>
                <defs>
                    <clipPath id="clip0_6664_4709">
                        <rect width="24" height="24" fill="white"
                              transform="translate(0.5 0.5)"/>
                    </clipPath>
                </defs>
            </svg> :
            <svg className="icon-arrow" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"
                 fill="none" aria-label="arrow icon">
                <path id="arrow-right-icon" d="M0 9H12.17L6.58 14.59L8 16L16 8L8 0L6.59 1.41L12.17 7H0L0 9Z"/>
            </svg>}

    </button>
}

DownloadCouponButton.propTypes = {
    caseId: PropTypes.string.isRequired,
    couponData: PropTypes.object,
    hasIdent: PropTypes.bool,
    setCouponData: PropTypes.func.isRequired,
    backToBranchUrl: PropTypes.string,
    search: PropTypes.string
}

function downloadPdf(caseId, setPdfData) {
    return getCouponPdf(caseId)
        .then(data => {
            setPdfData(data)
            return data
        })
}

function offerAsFile({documentData, mimeType, fileName}) {
    if (window.navigator.msSaveBlob) { // Internet Explorer
        const blob = b64toBlob(documentData, mimeType)
        window.navigator.msSaveBlob(blob, fileName)
    } else {
        const link = document.createElement('a')
        link.href = `data:application/octet-stream;base64,${documentData}`
        link.setAttribute('download', fileName)
        link.setAttribute('target', '_blank')
        document.body.appendChild(link)
        link.click()
        link.parentNode.removeChild(link)
    }
}

function b64toBlob(b64Data, contentType, sliceSize = 512) {
    const byteCharacters = atob(b64Data)
    const byteArrays = []
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.codePointAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
    }
    return new Blob(byteArrays, {type: contentType})
}
